import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getBrowserLocale,
  getUserLocaleVocabularyByLocale,
} from './localization.utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLocalizationList = createAsyncThunk<any>(
  'localization/getLocalizationList',
  async (_, { rejectWithValue }) => {
    try {
      const localizationList = await Promise.resolve({});

      const staticVocabulary = getUserLocaleVocabularyByLocale();

      return {
        translations: {
          ...staticVocabulary,
          ...localizationList,
        },
        locale: getBrowserLocale(),
      };
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_) {
      return rejectWithValue({ message: 'Error fetching phone cases list' });
    }
  }
);
